import { createSlice } from "@reduxjs/toolkit";

const meditationSlice = createSlice({
  name: "meditationAdd",
  initialState: {
    isMeditationAddOpen: false,
  },
  reducers: {
    toogleMeditationAdd: (state) => {
      state.isMeditationAddOpen = !state.isMeditationAddOpen;
    },
  },
});

export const { toogleMeditationAdd } = meditationSlice.actions;
export default meditationSlice.reducer;